<template>
  <div v-click-outside="close" class="main p-1">
    <div class="titleBox spaced" @click="!extended ? open() : close()">
      <div class="text-xl flex justify-center items-center">
        <input type="checkbox" @click.stop class="checkmark" v-model="allSelected">
        <p class="ml-2">{{ title }}</p>
      </div>
      <p v-show="!extended" class="mr-2"><i class="fas fa-caret-down"></i></p>
      <p v-show="extended" class="mr-2"><i class="fas fa-caret-up "></i></p>
    </div>
    <div class="tree mb-2" v-if="extended">
      <input v-model="searchInput" type="text" :placeholder="getTranslation('search')"
             class="border-shadow rounded-20 search ml-auto mr-auto mt-2 mb-2 pl-2 h-1/20">

      <div class="h-19/20 overflow-y-auto">
        <div v-for="(user, index) in filteredUsers" class="option" :key="index">
          <input class="checkmark" :disabled="disabled" :id="user.id" type="checkbox"
                 v-model="user.selected"/>
          <label class="ellipsis" :for="user.id"> {{ user.name }}</label>
        </div>
      </div>
      <div v-if="filteredUsers.length === 0">No users found</div>
    </div>
  </div>
</template>

<script>

import ClickOutside from 'vue-click-outside'
import EventBus from "../../services/EventBus";
import getTranslation from "../../mixins/getTranslation";

export default {
  name: "custom-user-dropdown",

  props: {
    title: {required: true},
    users: {required: true},
    disabled: {required: false, default: false}
  },

  mixins: [getTranslation],

  data() {
    return {
      extended: false,
      usersCopy: [],
      allUsers: this.users,
      searchInput: '',
      userSelected: [],
      backdoor: 0,
      selectAll: false,
    }
  },

  mounted() {
    this.backdoor++
  },

  created() {
    this.usersCopy = this.users

    EventBus.listen('close-dropdowns', this.close)
  },

  destroyed() {
    EventBus.destroy('close-dropdowns', this.close)
  },

  computed: {
    allSelected: {
      get() {
        if (!this.users.length) {
          return false
        }

        return this.users.find((user) => {
          return !user.selected
        }) === undefined
      },

      set(val) {
        this.users.forEach((user) => {
          user.selected = val
        })
      }
    },

    usersSelected() {
      this.backdoor++;
      return this.users.filter((user) => {
        return user.selected === true
      })
    },

    filteredUsers() {
      if (this.users.length === 0) {
        this.selectAll = false;
      }

      return this.users.filter((user) => {
        return user.name.toLowerCase().includes(this.searchInput.toLowerCase());
      })
    },
  },

  watch: {
    selectAll() {
      this.users.forEach((user) => {
        user.selected = this.selectAll;
      });
    }
  },

  methods: {
    open() {
      EventBus.fire('close-dropdowns')
      this.extended = true
    },

    close() {
      this.extended = false
    }
  },

  directives: {
    ClickOutside
  }
}
</script>

<style scoped>
.titleBox {
  display: flex;
  flex-direction: row;
  height: 55px;
  margin: 0;
  line-height: 55px;
  align-items: center;
}

.title {
  line-height: 40px;
}

.title:hover, .fas:hover {
  cursor: pointer;
}

.main {
  background: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  margin-bottom: 15px;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tree {
  max-height: 500px;
  height: fit-content;
  min-height: 100px;
  overflow-y: scroll;
}

.checkmark {
  margin-left: 10px;
  margin-right: 10px;
  height: 18px;
  width: 18px;
  background-color: teal;
}

.fas {
  margin-right: 15px;
  size: 200px !important;
}

.spaced {
  justify-content: space-between;
}

.option {
  height: 30px;
  line-height: 30px;
}

.search {
  height: 30px;
  line-height: 30px;
}
</style>
